var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotion4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8476_3697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z",
    fill: "url(#paint0_radial_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8594 55.7969C68.6853 55.7969 74.2188 50.2634 74.2188 43.4375C74.2188 36.6116 68.6853 31.0781 61.8594 31.0781C55.0335 31.0781 49.5 36.6116 49.5 43.4375C49.5 50.2634 55.0335 55.7969 61.8594 55.7969Z",
    fill: "url(#paint1_radial_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1406 55.7969C24.9665 55.7969 30.5 50.2634 30.5 43.4375C30.5 36.6116 24.9665 31.0781 18.1406 31.0781C11.3147 31.0781 5.78125 36.6116 5.78125 43.4375C5.78125 50.2634 11.3147 55.7969 18.1406 55.7969Z",
    fill: "url(#paint2_radial_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7656 31.375C61.0781 31.375 60.5156 30.8125 60.5156 30.125C60.5156 28.2188 58.9688 26.6719 57.0625 26.6719C55.1563 26.6719 53.6094 28.2188 53.6094 30.125C53.6094 30.8125 53.0469 31.375 52.3594 31.375C51.6719 31.375 51.1094 30.8125 51.1094 30.125C51.1094 26.8438 53.7813 24.1719 57.0625 24.1719C60.3438 24.1719 63.0156 26.8438 63.0156 30.125C63.0156 30.8125 62.4531 31.375 61.7656 31.375Z",
    fill: "url(#paint3_linear_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6562 31.375C26.9687 31.375 26.4062 30.8125 26.4062 30.125C26.4062 28.2188 24.8594 26.6719 22.9531 26.6719C21.0469 26.6719 19.5 28.2188 19.5 30.125C19.5 30.8125 18.9375 31.375 18.25 31.375C17.5625 31.375 17 30.8125 17 30.125C17 26.8438 19.6719 24.1719 22.9531 24.1719C26.2344 24.1719 28.9062 26.8438 28.9062 30.125C28.9062 30.8125 28.3438 31.375 27.6562 31.375Z",
    fill: "url(#paint4_linear_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1718 61.9688C37.4062 61.9688 34.625 61.5157 31.8437 60.5938C24.4843 58.1719 19.8281 53.4219 19.6406 53.2188C19.1562 52.7188 19.1718 51.9375 19.6718 51.4532C20.1718 50.9688 20.9531 50.9844 21.4375 51.4844C21.5312 51.5782 25.9531 56.0625 32.7187 58.25C41.7187 61.1719 50.4375 58.875 58.625 51.4219C59.1406 50.9532 59.9218 51 60.3906 51.5C60.8593 52.0157 60.8125 52.7969 60.3125 53.2657C55.4218 57.7188 50.2343 60.5 44.8906 61.5157C43.3281 61.8282 41.75 61.9688 40.1718 61.9688Z",
    fill: "url(#paint5_linear_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 21.9842C16.2969 21.9842 15.8438 21.7342 15.625 21.2967C15.3125 20.6717 15.5625 19.9217 16.1875 19.6248C16.4531 19.4998 22.8281 16.4061 31.2813 19.4998C31.9219 19.7342 32.2656 20.4529 32.0313 21.1092C31.7969 21.7498 31.0781 22.0936 30.4219 21.8592C22.9688 19.1404 17.3594 21.8436 17.2969 21.8748C17.125 21.9373 16.9375 21.9842 16.75 21.9842Z",
    fill: "url(#paint6_linear_8476_3697)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1719 21.9842C48.7188 21.9842 48.2656 21.7342 48.0469 21.2967C47.7344 20.6717 47.9844 19.9217 48.6094 19.6248C48.875 19.4998 55.25 16.4061 63.7031 19.4998C64.3594 19.7342 64.6875 20.4529 64.4531 21.1092C64.2188 21.7498 63.5 22.0936 62.8438 21.8592C55.3906 19.1404 49.7813 21.8436 49.7188 21.8748C49.5469 21.9373 49.3594 21.9842 49.1719 21.9842Z",
    fill: "url(#paint7_linear_8476_3697)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8476_3697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40 40) scale(42.6073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFED81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFEA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#FFE273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#FFBF48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FFA629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827,
    stopColor: "#FF8804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#FF9C1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#FFB53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FFD766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED81"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8476_3697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.8616 43.4416) scale(13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8476_3697",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1383 43.4416) scale(13.7067 13.7067)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#F78100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8476_3697",
    x1: 57.0503,
    y1: 24.1833,
    x2: 57.0503,
    y2: 32.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8476_3697",
    x1: 22.9495,
    y1: 24.1833,
    x2: 22.9495,
    y2: 32.1488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8476_3697",
    x1: 40,
    y1: 51.1197,
    x2: 40,
    y2: 61.8575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8476_3697",
    x1: 23.802,
    y1: 16.9937,
    x2: 23.802,
    y2: 23.5128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8476_3697",
    x1: 56.2214,
    y1: 16.9937,
    x2: 56.2214,
    y2: 23.5128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C98933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#985B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A3F1B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8476_3697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotion4);
export default __webpack_public_path__ + "static/media/emotion4.e8c482bcb316a0131a70e642d448de3a.svg";
export { ForwardRef as ReactComponent };